module.exports = __webpack_public_path__ + "static/media/banner_feygirl.cdbb4d3c.png";